export const ourPortfolio = [
  {
    text: "financial services",
    path: "/portfolio/financial-services",
  },
  {
    text: "hospitality & entertainment",
    path: "/portfolio/hospitality",
  },
  {
    text: "real estate & infrastructure",
    path: "/portfolio/real-estate",
  },
  {
    text: "agro-allied & FMCG",
    path: "/portfolio/agro-allied",
  },
  {
    text: "renewable energy",
    path: "/portfolio/renewable",
  },
  {
    text: "technology and media",
    path: "/portfolio/technology",
  },
  {
    text: "healthcare",
    path: "/portfolio/healthcare",
  },
];

export const joinUs = [
  {
    text: "career",
    path: "/joinus/career",
  },
  {
    text: "PAC Alumni Network",
    path: "/joinus/alumni",
  },
  {
    text: "Vendor Reg",
    path: "/joinus/vendor",
  },
];

export const resources = [
  {
    text: "Research",
    path: "/resources/research",
    external: true,
  },
  {
    text: "Stay Updated",
    path: "/resources/stay-updated",
  },
  // {
  //   text: "Newsletter",
  //   path: "/resources/newsletter",
  // },
];

export const countries = {
  type: "country",
  items: [
    {
      text: "Nigeria",
      email: "info@panfricancapitalholdings",
      phone: "+ 234-(1)-271-6899",
    },
    {/*{
      text: "Ghana",
      email: "info@panafricancapitalgh.com",
      phone: "+233 (0) 302 788523",
    },*/}
  ],
};

export const languages = {
  type: "language",
  items: [
    {
      text: "English",
      translation: "en",
    },
    {
      text: "French",
      translation: "fr",
    },
  ],
};
